module.exports = __webpack_public_path__ + "img/yszc-sj-m.0b6e5515.png";